import { useState, Children } from "react";
import { AnimatePresence, motion } from "framer-motion";
import styles from "../style/style.module.css";

const Tabs = ({ tabs, children, activeIndex }) => {
  const [activeTab, setActiveTab] = useState(activeIndex);
  // converting child to array jo we can aceess the child individually
  const child = Children.toArray(children);

  const animation = {
    hidden: {
      y: 20,
      opacity: 0,
    },
    visible: {
      y: 0,
      opacity: 1,
    },
    exit: {
      y: -20,
      opacity: 0,
    },
  };

  if (child.length === 0) {
    return <></>;
  }

  return (
    <div className={"flex flex-col items-center"}>
      <div className="flex justify-between gap-2 rounded-md border border-visLightGreen p-1 shadow-md">
        {tabs.map((tab, index) => (
          <button
            key={index}
            onClick={() => {
              setActiveTab(index);
            }}
            className={`relative box-border w-fit px-5 py-3 text-sm text-black md:text-18 ${activeTab === index ? `text-white delay-150 ${styles.textStroke}` : `hover:text-visOrange`} `}
            style={{
              WebkitTapHighlightColor: "transparent",
            }}
          >
            {activeTab === index && (
              <motion.span
                layoutId="indicator"
                className="absolute inset-0 rounded-md bg-visOrange"
                transition={{ type: "just", duration: 0.2 }}
              />
            )}
            <span className={`relative z-10`}>{tab}</span>
          </button>
        ))}
      </div>
      <div className="overflow-hidden pt-10">
        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab}
            className="relative w-full"
            variants={animation}
            initial={"hidden"}
            animate={"visible"}
            exit={"exit"}
            transition={{ duration: 0.2 }}
          >
            {child[activeTab]}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
};

export default Tabs;
